import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomLoader from '../common/CustomLoader';
import CustomSelect from '../home/collections/CustomSelect';
import ParentContentCard from '../common/ParentContentCard';
import { dropdownsForSource } from '../../common/utils/data_source-util';
import { convertFields, getFieldDataTypeValue } from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class SalesforceCollectionUpdate extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    fieldDatatypes: [],
    salesforceCollection: '',
  };
  async componentDidMount() {
    const { match, actions } = this.props;
    const { externalDbUuid, projectId, version, tableName } = match.params;
    await actions.loadExternalDatabaseForSalesforce({ projectId, externalDbUuid, version });
    const { externalDbSalesforce } = this.props.dataConnector;
    if (externalDbSalesforce) {
      await actions.getSchemaForSalesforceCollection({
        projectId,
        externalDbUuid,
        version,
        collectionName: tableName,
        setting: externalDbSalesforce.setting,
      });
      await actions.loadExternalDatabaseForSalesforce({ projectId, externalDbUuid, version });
      this.setState({ salesforceCollection: this.props.dataConnector.externalDbSalesforce });
    }
  }
  handleCancel = () => {
    const { match, history } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    history.push(`/data-connector/${version}/v/${projectId}/salesforce-update/${externalDbUuid}`);
  };
  handleSave = async () => {
    const { fieldDatatypes, salesforceCollection } = this.state;
    const { actions, match } = this.props;
    const { projectId, externalDbUuid, version, tableName } = match.params;
    const { completeData, setting } = salesforceCollection;
    const newArray = completeData['tables'];
    const selectedData = newArray.find((table) => table.name === tableName);
    const fieldData = selectedData.fields;
    const result = {};
    Object.keys(fieldData).map((fieldName, index) => {
      result[fieldName] = fieldDatatypes[fieldName]
        ? fieldDatatypes[fieldName].value
        : fieldData[fieldName];
    });
    const newResult = convertFields(result);
    const data = {
      version,
      collectionName: tableName,
      fields: newResult,
      projectId,
      setting,
      externalDatabaseId: externalDbUuid,
    };
    await actions.updateCollectionForSalesforce(data);
    await actions.updateExternaldatabaseForSalesforce({
      projectId,
      externalDbUuid,
      fields: newResult,
      version,
      collectionName: selectedData.name,
    });
    this.handleCancel();
  };
  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const { match, dataConnector } = this.props;
    const {
      loadExternalDatabaseForSalesforcePending,
      getSchemaForSalesforceCollectionPending,
      updateCollectionForSalesforcePending,
      updateExternaldatabaseForSalesforcePending,
    } = dataConnector;
    if (loadExternalDatabaseForSalesforcePending || getSchemaForSalesforceCollectionPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader
              loading={
                loadExternalDatabaseForSalesforcePending || getSchemaForSalesforceCollectionPending
              }
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }
    const { tableName } = match.params;
    const { completeData } = this.state.salesforceCollection;
    const tables = completeData ? completeData['tables'] : null;
    const selectedCollection = tables ? tables.find((table) => table.name === tableName) : null;
    const fieldData = selectedCollection ? selectedCollection.fields : null;
    return fieldData ? (
      <CommonPageComponent>
        <ParentContentCard title={'Update Collection  via Salesforce'} icon={'collection'}>
          <Formik initialValues={{ collectionTitle: selectedCollection.label }}>
            {({ values, handleChange, setFieldValue }) => (
              <Form className="ml-5">
                <div className="col-md-11 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'SalesForce collection name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={selectedCollection.label}
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Title"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Enter name for the collection name if  you want to change'}
                      value={selectedCollection.label}
                    >
                      <Field
                        type="text"
                        name="collectionTitle"
                        className="form-control form-control-sm"
                        placeholder="Collection Title"
                      />
                      <ErrorMessage name="collectionTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  <div className="mt-2">
                    <h5>
                      <b>Field Type Mapping</b>
                    </h5>
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      overflow: 'visible',
                      maxHeight: 'fit-content',
                      marginBottom: '10px',
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: '50%' }}>Fields</th>
                          <th style={{ width: '50%' }}>Types</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(fieldData).map((fieldName, index) => (
                          <tr key={index}>
                            <td style={{ width: '50%' }}>{fieldName}</td>
                            <td style={{ width: '50%' }}>
                              <CustomSelect
                                name={fieldName}
                                isMulti={false}
                                onChange={setFieldValue}
                                onChangeValue={this.handleFieldChange}
                                options={dropdownsForSource}
                                value={getFieldDataTypeValue(
                                  fieldName,
                                  fieldData,
                                  this.state.fieldDatatypes,
                                )}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Cancel"
                      type="button"
                      onClick={this.handleCancel}
                    >
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md"
                      title="Save Collection"
                      onClick={this.handleSave}
                      disabled={
                        updateCollectionForSalesforcePending ||
                        updateExternaldatabaseForSalesforcePending
                      }
                    >
                      <i className="wb webconnect-save-regular"></i> Update
                      <CustomLoader
                        loading={
                          updateCollectionForSalesforcePending ||
                          updateExternaldatabaseForSalesforcePending
                        }
                      />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : (
      <CommonPageComponent>
        <div className="text-center">
          <CustomLoader
            loading={
              loadExternalDatabaseForSalesforcePending || getSchemaForSalesforceCollectionPending
            }
            size="20px"
            color="#303453"
          />
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesforceCollectionUpdate);
